import { Star } from "lucide-react";
import CrudManager from "@/components/admin/CrudManager";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { ADMIN } from "@/constants/testIds";

const DEFAULT = { name: "", company: "", city: "", message: "", rating: 5, image: "", order: 0, published: true };

export default function AdminTestimonials() {
  return (
    <CrudManager
      title="Testimonials"
      subtitle="Add authentic testimonials from your business partners and retailers."
      endpoint="/admin/testimonials"
      defaultItem={DEFAULT}
      testId={ADMIN.testimonialsList}
      searchKeys={["name", "company", "message"]}
      listRender={(t) => (
        <div className="flex items-center gap-4">
          <div className="h-11 w-11 rounded-full bg-gold/10 text-gold flex items-center justify-center shrink-0 font-serif text-lg">
            {t.name?.[0] || "?"}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[0.65rem] tracking-widest uppercase text-gold">{t.company || "—"}{t.city ? ` • ${t.city}` : ""}</p>
            <p className="mt-0.5 font-serif text-lg text-foreground">{t.name}</p>
            <p className="text-xs text-foreground/60 line-clamp-1">"{t.message}"</p>
          </div>
          <div className="flex gap-0.5 shrink-0">
            {Array.from({ length: t.rating || 0 }).map((_, i) => <Star key={`star-${t.id}-${i}`} size={12} className="fill-gold text-gold" />)}
          </div>
        </div>
      )}
      formRenderer={(v, patch) => (
        <>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <Label>Name</Label>
              <Input className="mt-2 rounded-sm" value={v.name} onChange={(e) => patch({ name: e.target.value })} />
            </div>
            <div>
              <Label>Company</Label>
              <Input className="mt-2 rounded-sm" value={v.company} onChange={(e) => patch({ company: e.target.value })} />
            </div>
            <div>
              <Label>City</Label>
              <Input className="mt-2 rounded-sm" value={v.city} onChange={(e) => patch({ city: e.target.value })} />
            </div>
            <div>
              <Label>Rating (1-5)</Label>
              <Input type="number" min="1" max="5" className="mt-2 rounded-sm" value={v.rating} onChange={(e) => patch({ rating: Math.max(1, Math.min(5, parseInt(e.target.value) || 5)) })} />
            </div>
          </div>
          <div>
            <Label>Message</Label>
            <Textarea className="mt-2 rounded-sm min-h-[110px]" value={v.message} onChange={(e) => patch({ message: e.target.value })} />
          </div>
          <div className="grid md:grid-cols-2 gap-4 items-end">
            <div>
              <Label>Display Order</Label>
              <Input type="number" className="mt-2 rounded-sm" value={v.order} onChange={(e) => patch({ order: parseInt(e.target.value) || 0 })} />
            </div>
            <label className="flex items-center gap-3 p-3 rounded-sm border border-border/60 bg-secondary/40 cursor-pointer">
              <Switch checked={v.published} onCheckedChange={(c) => patch({ published: c })} />
              <span className="text-sm">Published</span>
            </label>
          </div>
        </>
      )}
    />
  );
}
